export const EMAIL_ADDRESS_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_NUMBER_PATTERN = /^\+?[\d\s\-().]{6,20}$/;

export const isEmailAddress = (value: unknown): value is string =>
  typeof value === "string" && EMAIL_ADDRESS_PATTERN.test(value);

export const isPhoneNumber = (value: unknown): value is string =>
  typeof value === "string" && PHONE_NUMBER_PATTERN.test(value);
